<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <textarea
      style="white-space: pre-line"
      class="form-control"
      [formControl]="formControlObj"
      [name]="detailInfo.title"
      [placeholder]="isOptionLoading ? 'Loading..' : 'Add text'"
    ></textarea>
  </app-field-title>
</div>
